import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../chunks/tslib.es6.js";
import t from "./Error.js";
import { EsriPromise as s } from "./Promise.js";
import { onAbortOrThrow as r, onAbort as e } from "./promiseUtils.js";
import l from "./Warning.js";
import { property as a } from "./accessorSupport/decorators/property.js";
import { subclass as n } from "./accessorSupport/decorators/subclass.js";

var i = "not-loaded",
    d = "loading",
    c = "failed",
    u = "loaded",
    h = function h(s) {
  var h = /*#__PURE__*/function (_s) {
    _inherits(h, _s);

    var _super = _createSuper(h);

    function h() {
      var _this;

      _classCallCheck(this, h);

      for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
        o[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(o)), _this._loadController = null, _this.loadError = null, _this.loadStatus = "not-loaded", _this._set("loadWarnings", []), _this.addResolvingPromise(new Promise(function (o) {
        var s = _this.load.bind(_assertThisInitialized(_this));

        _this.load = function (l) {
          var a = new Promise(function (o, s) {
            var e = r(l, s);
            _this.destroyed && s(new t("load:instance-destroyed", "Instance of '".concat(_this.declaredClass || _this.constructor.name, "' is already destroyed"), {
              instance: _assertThisInitialized(_this)
            })), _this._promiseProps.when(o, s).finally(function () {
              e && e.remove();
            });
          });

          if (_this.loadStatus === i) {
            _this._set("loadStatus", d);

            var _o = _this._loadController = new AbortController();

            s({
              signal: _o.signal
            }), e(_o.signal, function () {
              _this._promiseProps.abort();
            });
          }

          return o(), a;
        };
      })), _this.when(function () {
        _this._set("loadStatus", u), _this._loadController = null;
      }, function (o) {
        _this._set("loadStatus", c), _this._set("loadError", o), _this._loadController = null;
      });
      return _this;
    }

    _createClass(h, [{
      key: "loaded",
      get: function get() {
        return this.loadStatus === u;
      }
    }, {
      key: "loadWarnings",
      get: function get() {
        return this._get("loadWarnings");
      }
    }, {
      key: "load",
      value: function load() {
        return null;
      }
    }, {
      key: "cancelLoad",
      value: function cancelLoad() {
        var o;
        return this.isFulfilled() || (this._set("loadError", new t("load:cancelled", "Cancelled")), null == (o = this._loadController) || o.abort()), this;
      }
    }]);

    return h;
  }(s);

  return o([a({
    readOnly: !0
  })], h.prototype, "loaded", null), o([a({
    readOnly: !0
  })], h.prototype, "loadError", void 0), o([a()], h.prototype, "loadStatus", void 0), o([a({
    type: [l],
    readOnly: !0
  })], h.prototype, "loadWarnings", null), h = o([n("esri.core.Loadable")], h), h;
};

var p = /*#__PURE__*/function (_h) {
  _inherits(p, _h);

  var _super2 = _createSuper(p);

  function p() {
    _classCallCheck(this, p);

    return _super2.apply(this, arguments);
  }

  return p;
}(h(s));

p = o([n("esri.core.Loadable")], p), function (o) {
  function t(o) {
    return !(!o || !o.load);
  }

  o.LoadableMixin = h, o.isLoadable = t;
}(p || (p = {}));
var m = p;
export { m as default };